import $ from "jquery";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import listService from '../service/listService';
import Vue from 'vue';

let vm = new Vue({
    el: document.querySelector(".page-index"),
    data() {
        return {
            flag: false,
            lists: {},
        }
    },
    mounted() {
        this.list();
    },
    methods: {
        list() {
            listService.getList().then(data => {
                if (!data) {
                    return this.flag = false;
                }
                this.flag = true;
                this.lists = data;
            });

        }
    },

});

const render = () => {
  var mySwiper = new Swiper(".swiper-container", {
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1000,
  });

  $(document).ready(function(){
    $('.arrow').each(function(index,ele){
      $(ele).on('click',function(){
          $(this)
            .parent(".about-us-item")
            .toggleClass("show-more")
            .siblings()
            .removeClass("show-more")
            .toggleClass("hide");
        })
    });



  })

};
render();

